import {
  Autocomplete,
  AutocompleteValue,
  DropdownFilterSelect,
  makeStyles,
  MenuItem,
  MenuList,
} from '@freighthub/silhouette-core'
import { ChangeEvent, FC, useState } from 'react'

const useStyles = makeStyles((theme) => ({
  filterChip: {
    marginRight: theme.spacing(1),
  },
}))

type AutoCompleteFilterSelectProps = {
  label: string
  options: AutocompleteValue[]
  value: string
  onSelect: (option: AutocompleteValue) => void
  onInputChange?: (e: ChangeEvent, value: string) => void
  onClear: () => void
  testId: string
  freeFormEntry?: boolean
  placeholder?: string
  loading?: boolean
}

export const AutoCompleteFilterSelect: FC<AutoCompleteFilterSelectProps> = ({
  label,
  options,
  value,
  onSelect,
  onClear,
  onInputChange,
  testId,
  freeFormEntry,
  placeholder,
  loading,
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()
  const onOptionSelect = (data: AutocompleteValue) => {
    onSelect(data)
    setOpen(false)
  }

  return (
    <DropdownFilterSelect
      label={label}
      open={open}
      onClick={() => setOpen(true)}
      value={value ? [value] : []}
      onClear={onClear}
      className={classes.filterChip}
      data-testid={testId}
      {...props}
    >
      <Autocomplete
        // @ts-expect-error TS(2322) FIXME: Type '((e: ChangeEvent<Element>, value: string) =>... Remove this comment to see the full error message
        onInputChange={onInputChange}
        dataValue={value}
        options={options}
        onOptionSelect={onOptionSelect}
        label={placeholder}
        freeSolo={freeFormEntry}
        loading={loading}
        loadingText="Loading..."
      />
    </DropdownFilterSelect>
  )
}

type ListFilterSelectProps = {
  label: string
  selected: string[]
  displaySelected?: string[]
  onClear: () => void
  options: Record<'text' | 'value', string>[]
  onOptionSelect: (item: string) => void
  filterChipTestId: string
  menuItemTestId: string
}

export const ListFilterSelect: FC<ListFilterSelectProps> = ({
  label,
  selected,
  onClear,
  options,
  onOptionSelect,
  displaySelected,
  filterChipTestId,
  menuItemTestId,
  ...props
}) => {
  const classes = useStyles()
  return (
    <DropdownFilterSelect
      label={label}
      className={classes.filterChip}
      value={displaySelected || selected}
      onClear={onClear}
      data-testid={filterChipTestId}
      disableContentPadding
      {...props}
    >
      <MenuList disablePadding>
        {options.map((item) => (
          <MenuItem
            key={item.value}
            showCheckbox
            onClick={() => onOptionSelect(item.value)}
            selected={selected.indexOf(item.value) !== -1}
            data-testid={`${menuItemTestId}-${item.value}`}
          >
            {item.text}
          </MenuItem>
        ))}
      </MenuList>
    </DropdownFilterSelect>
  )
}
